import React from 'react';

import { IStackedHeroFields } from '../../../types/contentful';

import { getImageData } from '../../utils/contentful';

import RichText from '../RichText';
import { BlockContainer, Layout, Column } from '../Layout';
import { GlImage } from '../Image';

import { NoOverflowBox, ImageWrapper, HeadingText, Copy } from './styles';

export function StackedHero({
  copy,
  headingText,
  image,
  desktopImage
}: IStackedHeroFields) {
  return (
    <BlockContainer
      as="section"
      marginTop="blockMargin"
      revealOnScroll={false}
      data-blockid="stacked-hero"
      data-testid="stacked-hero"
      data-e2e="hero"
    >
      <Layout gutter={{ 0: 'ml', desktop: 'l' }}>
        <Column size={12}>
          <NoOverflowBox>
            <ImageWrapper>
              <GlImage
                {...getImageData(desktopImage || image)}
                loading="eager"
                heroImage={true}
              />
            </ImageWrapper>
            <ImageWrapper isMobile={true}>
              <GlImage
                {...getImageData(image)}
                loading="eager"
                heroImage={true}
              />
            </ImageWrapper>
          </NoOverflowBox>
        </Column>

        <Column size={{ 0: 9, tablet: 6 }} paddingBottom={{ 0: 'xs' }}>
          <HeadingText
            as="h1"
            fontWeight="h1"
            fontSize={{ 0: 'h1_0', desktop: 'h1_tablet' }}
            colour="defaultText"
          >
            {headingText}
          </HeadingText>
        </Column>
        {copy && (
          <Column size={{ 0: 10, tablet: 4 }}>
            <Copy>
              <RichText data={copy} />
            </Copy>
          </Column>
        )}
      </Layout>
    </BlockContainer>
  );
}
